import { render, staticRenderFns } from "./InvestorWishlistItem.vue?vue&type=template&id=120e1a26&scoped=true&"
import script from "./InvestorWishlistItem.vue?vue&type=script&lang=js&"
export * from "./InvestorWishlistItem.vue?vue&type=script&lang=js&"
import style0 from "./InvestorWishlistItem.vue?vue&type=style&index=0&id=120e1a26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120e1a26",
  null
  
)

export default component.exports